import { render, staticRenderFns } from "./r-trigger-ship.vue?vue&type=template&id=86925084&scoped=true"
import script from "./r-trigger-ship.vue?vue&type=script&lang=js"
export * from "./r-trigger-ship.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-ship.vue?vue&type=style&index=0&id=86925084&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86925084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86925084')) {
      api.createRecord('86925084', component.options)
    } else {
      api.reload('86925084', component.options)
    }
    module.hot.accept("./r-trigger-ship.vue?vue&type=template&id=86925084&scoped=true", function () {
      api.rerender('86925084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-ship.vue"
export default component.exports